import { List } from "immutable";
import { selectData } from "fe-shared/utils/reducerUtils";
import {
  WEBBOT_CLEAR_WAITS,
  WEBBOT_CONNECTED,
  WEBBOT_CONNECTING,
  WEBBOT_CONNECTION_ERROR,
  WEBBOT_MESSAGE_RECEIVED_FROM_SDK,
  WEBBOT_MESSAGE_SENT_TO_SDK,
  WEBBOT_SET_IS_TYPING,
  WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT,
  ADD_PREVIEW,
  WEBBOT_PREVIOUS_MESSAGES,
  WEBBOT_HIDE_WAITS,
  WEBBOT_RESET_CHAT,
  WEBBOT_RESTARTING_CHAT,
  WEBBOT_SAVE_CVARS,
  WEBBOT_CLEAR_MESSAGES,
} from "actions/const";

import {
  STATE_WEBBOT_DEFAULT,
  STATE_WEBBOT_MESSAGES,
  STATE_WEBBOT_CONNECTING,
  STATE_WEBBOT_CONNECTION,
  STATE_WEBBOT_ERROR,
  STATE_WEBBOT_IS_TYPING,
  STATE_WEBBOT_IS_RESTARTING_CHAT,
  STATE_WEBBOT_CVARS_SAVED,
} from "./default";
import {
  addPreview,
  setPreviousMessages,
  hidePendingMessages,
  newMessageReceived,
  messageSentToSdk,
  hideWaits,
  showMessagesBeforeWait,
} from "./utils";
import { createReducer } from "../base";
import { getBotId, getWebchatKey } from "../../actions/webbot";
import { encodeString } from "../../utils";

export default createReducer(STATE_WEBBOT_DEFAULT, {
  [WEBBOT_CONNECTING]: state => state.set(STATE_WEBBOT_CONNECTING, true),
  [WEBBOT_CONNECTION_ERROR]: (state, action) =>
    state
      .set(STATE_WEBBOT_CONNECTION, false)
      .set(STATE_WEBBOT_CONNECTING, false)
      .set(STATE_WEBBOT_ERROR, action.payload),
  [WEBBOT_CONNECTED]: state =>
    state
      .set(STATE_WEBBOT_CONNECTION, true)
      .set(STATE_WEBBOT_CONNECTING, false)
      .set(STATE_WEBBOT_ERROR, null),
  [WEBBOT_MESSAGE_RECEIVED_FROM_SDK]: newMessageReceived,
  [WEBBOT_MESSAGE_SENT_TO_SDK]: messageSentToSdk,
  [WEBBOT_CLEAR_MESSAGES]: state => {
    const botId = getBotId();
    const webchatKey = getWebchatKey();
    if (botId && webchatKey) {
      localStorage.removeItem(
        `${encodeString(`allMessages-${botId}-${webchatKey}`)}`
      );
    }
    return state.set(STATE_WEBBOT_MESSAGES, List());
  },
  [WEBBOT_SET_IS_TYPING]: (state, action) =>
    state.set(STATE_WEBBOT_IS_TYPING, action.payload),
  [WEBBOT_SHOW_EVERYTHING_BEFORE_WAIT]: showMessagesBeforeWait,
  [WEBBOT_CLEAR_WAITS]: hidePendingMessages,
  [WEBBOT_HIDE_WAITS]: hideWaits,
  [WEBBOT_PREVIOUS_MESSAGES]: setPreviousMessages,
  [ADD_PREVIEW]: addPreview,
  [WEBBOT_RESTARTING_CHAT]: state =>
    state.set(STATE_WEBBOT_IS_RESTARTING_CHAT, true),
  [WEBBOT_RESET_CHAT]: state =>
    STATE_WEBBOT_DEFAULT.set(
      STATE_WEBBOT_CVARS_SAVED,
      selectData(state, STATE_WEBBOT_CVARS_SAVED)
    ),
  [WEBBOT_SAVE_CVARS]: (state, { data }) =>
    state.set(STATE_WEBBOT_CVARS_SAVED, data),
});

export * from "./selectors";
export * from "./default";
